export default __webpack_public_path__ + "static/media/logo-white-with-tagline.d38d3991.png";